export default async function ({ $auth, context }) {
  const user = await $auth.user
  if (user) {
    $auth.$state.loggedIn = true;
    $auth.$state.user = user;
  } else {
    // redirect to homepage
    // redirect('/')
  }
}